/**
 * Customer Perception Insights Constants
 */

/** Tab identifiers */
export const PERCEPTION_TABS = {
    FLOW_RIBBONS: "flow-ribbons",
    JOURNEY_BOARD: "journey-board"
} as const;

/** Sankey column identifiers */
export const SANKEY_COLUMNS = {
    PREVIEW_PIPELINE: "PREVIEW PIPELINE",
    DEPLOYMENT_STAGE: "DEPLOYMENT STAGE",
    TOP_ENGINEERING_FRICTION: "TOP ENGINEERING FRICTION"
} as const;

/** Friction category colors - matches backend */
export const FRICTION_COLORS: Record<string, string> = {
    "Access Control / RBAC": "#8B5CF6",
    "Missing Capability / Feature Gap": "#F97316",
    "Latency / Performance": "#EAB308",
    "Detection Accuracy / False Positives": "#EF4444",
    "No friction logged": "#9CA3AF",
    "Output Formatting / Presentation": "#3B82F6",
    "Integration / Connectivity": "#06B6D4",
    "UX / Workflow Friction": "#6366F1"
};

/** Pipeline stage colors - matches backend */
export const PIPELINE_COLORS: Record<string, string> = {
    "Prospect / Engaged": "#06B6D4",
    "Private Preview": "#3B82F6",
    "Limited Public Preview": "#10B981",
    "Launch Partner": "#8B5CF6"
};

/** Deployment stage colors - matches backend */
export const DEPLOYMENT_COLORS: Record<string, string> = {
    "Evaluating": "#8B5CF6",
    "Engaged": "#3B82F6",
    "Deployed": "#10B981",
    "Blocked": "#EF4444",
    "Stalled": "#9CA3AF"
};

/** Theme colors - consistent with Security 360 branding */
export const THEME = {
    primary: "#0078D4",
    primaryLight: "#E6F2FA",
    primaryDark: "#005A9E",
    
    background: "#F8FAFC",
    surface: "#FFFFFF",
    cardBg: "#FAFBFC",
    
    textPrimary: "#1A1A2E",
    textSecondary: "#64748B",
    textMuted: "#94A3B8",
    
    border: "#E2E8F0",
    borderLight: "#F1F5F9",
    
    success: "#059669",
    successLight: "#D1FAE5",
    
    warning: "#D97706",
    warningLight: "#FEF3C7",
    
    error: "#DC2626",
    errorLight: "#FEE2E2",
    
    purple: "#7C3AED",
    purpleLight: "#EDE9FE",
    
    info: "#0EA5E9",
    infoLight: "#E0F2FE"
};

/** Live Preview Usage time range options */
export const TIME_RANGE_OPTIONS = [
    { key: "Last 1 day", text: "Last 1 day" },
    { key: "Last 7 days", text: "Last 7 days" },
    { key: "Last 30 days", text: "Last 30 days" }
];

/** Local storage keys for persisted filters */
export const STORAGE_KEYS = {
    SELECTED_STAGE: "customerPerception_selectedStage",
    TIME_RANGE: "customerPerception_timeRange",
    ACTIVE_TAB: "customerPerception_activeTab"
};
